import * as Yup from 'yup';

export const transferMoneyValidation = {
    user_id: Yup.string().trim()
        .required("Please Select user"),
    amount: Yup.string().trim()
        .required("Please enter amount")
        .matches(/^\d+(\.\d+)?$/, 'Please enter valid number.'),
}
